import { render } from "./level-7.vue?vue&type=template&id=05546523&ts=true"
import script from "./level-7.vue?vue&type=script&lang=ts"
export * from "./level-7.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__